import { render, staticRenderFns } from "./userContactsCard.vue?vue&type=template&id=15a63d1c"
import script from "./userContactsCard.vue?vue&type=script&lang=js"
export * from "./userContactsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports